// extracted by mini-css-extract-plugin
export default {"header":"page-template_header__rx3Zl","row":"page-template_row__U7gHG","placeHolderShimmer":"page-template_placeHolderShimmer__xaP-f"};